document.addEventListener('variant:update', (event) => {
  const customEvent = /** @type {{ detail?: { data?: { variant?: any } } }} */ (event);
  const variant = customEvent.detail?.data?.variant;
  if (!variant) return;

  const priceEl = document.querySelector('[data-variant-price]');
  if (!priceEl) return;

  if (variant.price_html) {
    priceEl.innerHTML = variant.price_html;
  }
});
